import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

// Bump this on every deploy that changes generated imagery so phones/CDN edges
// never serve stale product images from a previous build.
export const IMAGE_VERSION = "2026-09-27-2";

export const vimg = (url) =>
  url && !url.includes("?") ? `${url}?v=${IMAGE_VERSION}` : url;

export default api;
